const defaultLocale = 'de-DE';
const defaultCurrency = 'EUR';

const euroFormat = new Intl.NumberFormat(defaultLocale, {
  style: 'currency',
  currency: defaultCurrency,
});

export function toEuro(value: unknown): string | unknown {
  return formatToCurrency(value, euroFormat);
}

export function toCurrency(
  value?: string | number,
  currency = defaultCurrency,
  locale = defaultLocale,
) {
  const format = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  });
  return formatToCurrency(value, format);
}

function formatToCurrency(value: unknown, format: Intl.NumberFormat): string {
  if (value === undefined || value === null) {
    return '';
  }
  if (typeof value !== 'string' && typeof value !== 'number') {
    return '';
  }

  if (typeof value === 'number') {
    return format.format(value);
  }

  try {
    const parsed = parseFloat(value);
    return format.format(parsed);
  } catch {
    return value;
  }
}
